const stores = {
    state () {
        return {
            loinStatus:false,
            lang:'en',
            userData:{
            },
            pageData:{
                title:''
            },
            sideMenu:[],
            token: '',
            gamePlayerValue:4,
            playerMembers:[],
            loadingStatus:false,
            progressStatue:false,
            progressValue:0,
            logsView:false,
            logs:[]
        }
    },
    mutations: {
        setPlayer(state, data){
            console.log(`setPlayer:`,data)
            state.gamePlayerValue = data.gamePlayerValue
            state.playerMembers = data.playerMembers
            console.log(`setPlayer:`,state.gamePlayerValue,state.playerMembers)
        },
        getPlayer(state){
            console.log(`getPlayer:`,state.gamePlayerValue,state.playerMembers)
            return {
                gamePlayerValue:state.gamePlayerValue,
                playerMembers:state.playerMembers
            }
        },
        clearPlayer(state){
            state.gamePlayerValue = 0
            state.playerMembers = []
        },
        setLang (state, value) {
            state.lang = value;
        },
        setUserinfo (state,data) {
            console.log('setUserinfo')
            state.token = data
            localStorage.setItem('auupl_userInfo',state.token)
            state.loinStatus = true
        },
        userLogOut(state){
            console.log('userLogOut')
            state.token = '';
            state.sideMenu = []
            localStorage.auu_page = 'Search'
            localStorage.clear()
            state.loinStatus = false
        },
        checkLogin(state){
            console.log('checkLogin')
            let userInfo = localStorage.getItem('auupl_userInfo')
            console.log(`auupl_userInfo : ${userInfo}`);
            if ( userInfo ){ //有資料等於登入了
                state.loinStatus = true
                state.token = userInfo
            }else{ //沒資料等於沒登入
                state.loinStatus = false
            }
            console.log(state.loinStatus);
            return state.loinStatus;
        },
        getToken(state){
            let userInfo = localStorage.getItem('auupl_userInfo')
            return userInfo;
        },
        setPageData(state,data){
            console.log('setPageData->',data)
            state.pageData.title = data.title
            state.pageData.path = data.path
        },
        setSideMenu(state,data){
            console.log('setSideMenu->',data)
            state.sideMenu = []
            state.sideMenu = data.data;
            localStorage.setItem('sideMenu',JSON.stringify(state.sideMenu))
            state.loinStatus = true
        },
        ADD_LOG(state, payload) {
            state.logs.push(payload)
        },
        SET_LOGS_VIEW(state, val) {
            state.logsView = val
        },
    },
    actions: {
        addLog({ commit }, log) {
        commit('ADD_LOG', log)
        }
    },
    getters: {
      getLang(state) {
        return state.lang
      }
    }
}


export default stores